module.exports = __webpack_public_path__ + "static/yuan_ti_mind_whisperer-9eba98b81b752e8bd2bac041cfbca618.jpeg";